import { render, staticRenderFns } from "./LosOperadoresOperacoes.vue?vue&type=template&id=0b89e4ae&scoped=true&"
import script from "./LosOperadoresOperacoes.vue?vue&type=script&lang=js&"
export * from "./LosOperadoresOperacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b89e4ae",
  null
  
)

export default component.exports